<div class="login-container d-flex justify-content-center align-items-center vh-100">
  <div class="card p-4 shadow" style="width: 400px;">
    <!-- Logo -->
    <div class="text-center mb-4">
      <i class="bi bi-user"></i>
      <h2 class="login-title">{{'title_signin'|translate}}</h2>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="email" class="form-label">{{'label_email'|translate}}</label>
        <input id="email" type="text" class="form-control" formControlName="email"
          [placeholder]="'placeholder_email'|translate" inputRequired />
      </div>

      <!-- Password -->
      <div class="mb-3">
        <label for="password" class="form-label">{{'label_password'|translate}}</label>
        <input id="password" type="password" class="form-control" formControlName="password"
          [placeholder]="'placeholder_password'|translate" inputRequired />
      </div>

      <!-- Stay signed in -->
      <div class="form-check mb-3 d-flex align-items-center">
        <input id="staySignedIn" type="checkbox" class="form-check-input me-2" formControlName="staySignedIn" />
        <label for="staySignedIn" class="form-check-label">
          {{'label_stay_signed_in'|translate}}
        </label>
      </div>

      <!-- Sign In Button -->
      <button type="submit" class="btn btn-primary w-100" [disabled]="loginForm.invalid || isLoading">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        {{'button_signin'|translate}}
      </button>
    </form>

  </div>
</div>
